import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { WA_MESSAGES, waLink } from "@/lib/api";

const OPTIONS = [
  { key: "prodotto", label: "Info prodotto" },
  { key: "ordine", label: "Assistenza ordine" },
  { key: "spedizioni", label: "Info spedizioni" },
];

export const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-2">
      {open && (
        <div data-testid="whatsapp-menu" className="rise bg-[#F5F0E8] border border-[#D5B98C] shadow-[0_10px_30px_-10px_rgba(57,37,29,.35)] w-60">
          <div className="px-4 py-3 text-[11px] uppercase tracking-[0.2em] text-[#956842] border-b border-[#D5B98C]/50">Scrivici su WhatsApp</div>
          {OPTIONS.map((o) => (
            <a key={o.key} data-testid={`whatsapp-option-${o.key}`} href={waLink(WA_MESSAGES[o.key])} target="_blank" rel="noopener noreferrer" className="block px-4 py-3 text-sm hover:bg-[#D5B98C]/25 transition-colors">
              {o.label}
            </a>
          ))}
        </div>
      )}
      <button
        data-testid="whatsapp-floating-button"
        onClick={() => setOpen((v) => !v)}
        aria-label="WhatsApp"
        className="w-12 h-12 rounded-full bg-[#39251D] text-[#F5F0E8] flex items-center justify-center shadow-[0_8px_24px_-8px_rgba(57,37,29,.6)] hover:bg-[#956842] transition-colors"
      >
        {open ? <X className="w-5 h-5" /> : <MessageCircle className="w-5 h-5" strokeWidth={1.6} />}
      </button>
    </div>
  );
};
